
import Layout from '@/layout'

const epcRouter = {
  path: '/epc',
  component: Layout,
  redirect: '/epc/partsChange',
  name: 'partsChange',
  meta: {
    title: 'routeAuxiliary',
    icon: 'icons6'

  },
  children: [
    {
      path: 'partsChange',
      component: () => import('@/views/epc/partsChange'),
      name: 'PartsChange',
      meta: { title: 'routePartChangeInfo', icon: 'icons61', code: 'parts:change:information' }
    },
    {
      path: 'search-parts',
      component: () => import('@/views/epc/searchParts'),
      name: 'SearchParts',
      meta: { title: 'routeAccessory', icon: 'icons62', code: 'accessories:search' }
    },
    {
      path: 'searchImgParts',
      component: () => import('@/views/epc/searchImgParts'),
      name: 'SearImgchParts',
      meta: { title: 'routeAtlas', icon: 'icons3', code: 'photo:search' }
    },
    {
      path: 'searchCarparts',
      component: () => import('@/views/epc/searchCarParts'),
      name: 'SearchCarParts',
      meta: { title: 'routeVehicleAtlas', icon: 'icons2', code: 'code:photo:management' }
    },
    {
      path: 'searchVinparts',
      component: () => import('@/views/epc/searchVinParts'),
      name: 'SearchVinParts',
      meta: { title: 'routeVinQuery', icon: 'icons65', code: 'vin:photo:management' }
    },
    {
      path: 'vehicleAtlas',
      component: () => import('@/views/epc/vehicleAtlas'),
      name: 'VehicleAtlas',
      meta: { title: 'routeVehicleParts', icon: 'icons61', code: 'epc:accessories:details' }
    },
    {
      path: 'cart',
      component: () => import('@/views/epc/cart'),
      name: 'Cart',
      meta: { title: '购物车', icon: 'search-vin', noCache: true, code: 'epc:function' },
      hidden: true
    },
    {
      path: 'order',
      component: () => import('@/views/epc/order'),
      name: 'Order',
      meta: { title: 'PMS预订单', icon: 'clipboard', noCache: true, code: 'epc:function' },
      hidden: true
    },
    {
      path: '/generateOrder',
      component: () => import('@/views/epc/generateOrder'),
      name: 'generateOrder',
      meta: { title: '购物车清单', icon: 'clipboard', code: 'epc:function' },
      hidden: true
    },
    {
      path: '/orderDetail',
      component: () => import('@/views/epc/orderDetail'),
      name: 'orderDetail',
      meta: { title: '订单详情', icon: 'clipboard', code: 'epc:function' },
      hidden: true
    }
  ]
}

export default epcRouter
